
// bluetooth
const GET_CONNECTBLEDATA = 'GET_CONNECTBLEDATA'
const GET_INFODATA = 'GET_INFODATA'
const GET_CONNECTRINTDATA = 'GET_CONNECTRINTDATA'

export {
  GET_CONNECTBLEDATA,
  GET_INFODATA,
  GET_CONNECTRINTDATA
}
